import {
  humanCalculators_Fr,
  islamicCalculators_Fr,
  studyCalculators_Fr,
  healthCalculators_Fr,
  financialCalculators_Fr,
  womenCalculators_Fr,
  mathCalculators_Fr,
  physicsCalculators_Fr,
  otherCalculators_Fr,
  chemistryCalculators_Fr,
} from "./ConstantsFr";
import SharedHelmet from "./Helmet";
import { useState } from "react";
import { Icons } from "../../Components/Icons";

const TITLE = "Toutes les calculatrices";
const DESCRIPTION =
  "Retrouvez ici toutes les calculatrices disponibles sur notre site : santé, mathématiques, physique, chimie, finances, islamiques, études et bien plus encore.";
const KEYWORDS = "toutes les calculatrices, calculatrices en ligne, calculatrice santé, calculatrice mathématiques, calculatrice physique";
const OG_URL = "https://do-calculate.com/fr/all-calculators/";

const cardData = [
  {
    cardTitle: "Calculatrices de santé",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators_Fr,
    calculatorUrl: "/fr/health-calculators/",
  },
  {
    cardTitle: "Calculatrices de mathématiques",
    cardIcon: <Icons.Calculate />,
    cardItems: mathCalculators_Fr,
    calculatorUrl: "/fr/math-calculators/",
  },
  {
    cardTitle: "Calculatrices de physique",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators_Fr,
    calculatorUrl: "/fr/physics-calculators/",
  },
  {
    cardTitle: "Calculatrices de chimie",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators_Fr,
    calculatorUrl: "/fr/chemistry-calculators/",
  },
  {
    cardTitle: "Calculatrices financières",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators_Fr,
    calculatorUrl: "/fr/financial-calculators/",
  },
  {
    cardTitle: "Calculatrices pour femmes",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators_Fr,
    calculatorUrl: "/fr/women-calculators/",
  },
  {
    cardTitle: "Calculatrices islamiques (Zakat)",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators_Fr,
    calculatorUrl: "/fr/islamic-calculators/",
  },
  {
    cardTitle: "Calculatrices de temps et de date",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators_Fr,
    calculatorUrl: "/fr/human-calculators/",
  },
  {
    cardTitle: "Calculatrices d'études (GPA)",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators_Fr,
    calculatorUrl: "/fr/study-calculators/",
  },
  {
    cardTitle: "Autres calculatrices",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators_Fr,
    calculatorUrl: "/fr/other-calculators/",
  },
];

function AllCalculators() {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCardData = cardData
    .map((card) => ({
      ...card,
      cardItems: card.cardItems.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((card) => card.cardItems.length > 0);

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="p-3 mb-2 bg-success text-white text-center">
        <b>{TITLE}</b>
      </div>
      <div className="mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          placeholder="Rechercher une calculatrice..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div
        className="row row-cols-1 row-cols-md-4 g-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {filteredCardData.map((card, index) => (
          <div className="col" key={index} style={{ paddingBottom: "10px" }}>
            <div>
              <h2 style={{ fontSize: "16px" }}>
                {card.cardIcon}{" "}
                <a href={card.calculatorUrl} className="item-link">
                  {card.cardTitle}
                </a>
              </h2>
              <ul style={{ padding: 0, listStyleType: "none" }}>
                {card.cardItems.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <a
                      href={item.link}
                      className="item-link"
                      style={{ fontSize: "14px" }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        Pour toute question, suggestion de nouvelle calculatrice ou signalement d'un problème, contactez-nous à : info@do-calculate.com
      </div>
    </div>
  );
}

export default AllCalculators;
